export class EntPesticidesFilter {
  periodStart: string | null = null;
  periodEnd: string | null = null;
  pesticidesTypeId: number | null = null;
  territorialUnitIds: number[] | null = null;

  neededTonnes: number | null = null;
  suppliedTonnes: number | null = null;

  createdFrom: string | null = null;
  createdTo: string | null = null;
  deleted: boolean = false;
  page: number = 1;
  size: number = 30;
}



export class EntReportPesticidesFilter {
  periodStart: string|null = null;
  periodEnd: string|null = null;
  language: string|null = null;
}

